export function formatPersonRef(ref: unknown): string {
  if (ref == null || ref === "") return "";
  if (typeof ref === "string") return ref.trim();
  const record = ref as Record<string, unknown>;
  const name =
    (typeof record.name === "string" && record.name.trim()) ||
    (typeof record.fullName === "string" && record.fullName.trim()) ||
    "";
  if (name) return name;
  const joined = [record.firstName, record.lastName].filter(Boolean).join(" ").trim();
  if (joined) return joined;
  if (typeof record.email === "string" && record.email.trim()) return record.email.trim();
  return "";
}

export function firstDefinedPatientValue(
  patient: Record<string, unknown> | null | undefined,
  keys: string[],
): unknown {
  if (!patient) return null;
  for (const key of keys) {
    const value = patient[key];
    if (value !== undefined && value !== null && value !== "") return value;
  }
  return null;
}

export function firstNonEmptyPatientString(
  patient: Record<string, unknown> | null | undefined,
  keys: string[],
): string {
  if (!patient) return "";
  for (const key of keys) {
    const value = patient[key];
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
}

export function getPatientTimeZone(patient: Record<string, unknown> | null | undefined): string | undefined {
  const facility = patient?.facilityId as Record<string, unknown> | undefined;
  const organization = patient?.organizationId as Record<string, unknown> | undefined;
  const tz =
    facility?.timezone ||
    patient?.resolvedTimezone ||
    organization?.timezone ||
    patient?.timezone;
  return typeof tz === "string" && tz.trim() ? tz.trim() : undefined;
}
